export default __webpack_public_path__ + "static/tab3Img-f82db8b18b329a8f62d1c3463a1bc2cc.png";